// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '케이엠에스제약',
  targetSheetName: '26년생동제품',
  headerRowIndex: 6,
  headerRowCount: 1,
  dataStartRowIndex: 7,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제 품 명',
    price: '보험약가',
    commissionRate: '변경후',
  },
  requiredHeaders: [
    'NO',
    '구 분',
    '제 품 명',
    '성 분 명',
    '보험코드',
    '보험약가',
    '생동,약동',
    '변경전',
    '변경후',
  ],
});
